module.exports = __webpack_public_path__ + "img/heart-white-full.2aaace1f.svg";